import { Component } from '@angular/core';

@Component({
  selector: 'modal-retos-pausados',
  templateUrl: 'modal-retos-pausados.html'
})
export class ModalRetosPausadosComponent {

  show: boolean = false;

  constructor() {
  }

  close() {
    this.show = !this.show;
  }

}



// WEBPACK FOOTER //
// ./src/components/modal-retos-pausados/modal-retos-pausados.ts